import ordersPendingConfirmationImg from './orders-pending-confirmation.png'
import orderConfirmationImg from './order-confirmation.png'
import orderAmendImg from './order-amend.png'

export const images = {
  ordersPendingConfirmationImg,
  orderConfirmationImg,
  orderAmendImg,
}
